import React from "react";
import ProcessedImage from "../../../components/common/ProcessedImage/ProcessedImage";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./ParagraphKeyFactsFigures.module.scss";

export interface ParagraphKeyFactsFiguresProps {
	heading: string;
	description: string;
	iconSrc: string;
	iconAlt: string;
	jumpLinksTitle?: string;
}

export const getParagraphKeyFactsFiguresProps = ({
	field_heading,
	field_jump_links_title,
	field_description,
	relationships: { field_icon },
}: Queries.ParagraphKeyFactsFiguresDataFragment): ParagraphKeyFactsFiguresProps => ({
	heading: field_heading,
	jumpLinksTitle: field_jump_links_title,
	description: field_description,
	iconSrc: field_icon?.field_media_image?.uri,
	iconAlt: field_icon?.field_media_image?.alt,
});
export const ParagraphKeyFactsFigures: React.FC<
	ParagraphKeyFactsFiguresProps
> = ({ heading, description, iconSrc, jumpLinksTitle }) => {
	return (
		<WrappedSection sectionName="ParagraphKeyFactsFigures">
			<div className={styles.paragraphkeyfactsfigures}>
				<div className={styles.imagecontainer}>
					{iconSrc && (
						<ProcessedImage
							className={styles.image}
							src={iconSrc}
							alt=""
							aria-hidden
							dimensions="200x200"
							width={200}
							height={200}
							loading={"lazy"}
						/>
					)}
				</div>
				<div className={styles.info}>
					{heading && (
						<h3
							className={styles.title}
							{...(jumpLinksTitle
								? { "data-jumplinkstitle": jumpLinksTitle }
								: {})}
						>
							{heading}
						</h3>
					)}
					<p className={styles.text}>{description}</p>
				</div>
			</div>
		</WrappedSection>
	);
};

export default ParagraphKeyFactsFigures;
